import { render, staticRenderFns } from "./newInvitation.vue?vue&type=template&id=58195f65&scoped=true&"
import script from "./newInvitation.vue?vue&type=script&lang=js&"
export * from "./newInvitation.vue?vue&type=script&lang=js&"
import style0 from "./newInvitation.vue?vue&type=style&index=0&id=58195f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58195f65",
  null
  
)

export default component.exports